import React, { useEffect, useState } from 'react';
import { Form, Input, Select, Card, Row, Col,Modal,
   Upload, message, UploadProps, DatePicker, FormInstance, InputNumber, Button } from 'antd';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { LotCodeDropDown, LotInformationRequest, LotNoInfo, LotNumberRequest, WorkStationCategoryReq, WorkStationsDropDown } from '@gtpl/shared-models/production-management';
import { SoakingAssignmentService, ProdInvService, ProductionInventoryService, WorkstationService } from "@gtpl/shared-services/production";
import { Link, Redirect } from 'react-router-dom';

import './assign-beheading-to-grading.css';
import { OperationTypeEnum, WorkStationTypeEnum } from '@gtpl/shared-models/common-models';
import { GradingService } from '../../../../../../shared-services/production/src/lib/grading.service';
import moment from 'moment';
const { Option } = Select;
import { QrcodeOutlined } from '@ant-design/icons';
import {QrContainer} from '../../../assign-rm-inventory/src/lib/qr-scanner'

/* eslint-disable-next-line */
export interface AssignBeheadingToGradingProps {}

export function AssignBeheadingToGrading(
  props: AssignBeheadingToGradingProps
) {
  const [assignGradingForm] = Form.useForm();
  const [lotNumbers, setLotNumbers] = useState<LotCodeDropDown[]>([]);
  const service = new ProductionInventoryService();
  const gradingService = new GradingService();
  const [lotNoInfo, setLotNoInfo] = useState<LotNoInfo>(undefined);
  const [boxWeight, setBoxWeight] = useState<number>(0);
  const [workStations, setWorkStations] = useState<WorkStationsDropDown[]>([]);
  const workstationService = new WorkstationService();
  const [disable, setDisable] = useState<boolean>(false);
  const [showQrSacn, setShowQrScan] = useState<boolean>(false);

  useEffect(() => {
    // assignGradingForm.setFieldsValue({workStationType:"INTERNAL"});

    getLotNumbers();
    getWorkStations();
  }, [])

  const getLotNumbers = () => {
    const plant = Number(localStorage.getItem('unit_id'))
    const lotNoReq = new LotNumberRequest(plant, OperationTypeEnum.GRADING);
    service.getLotNumbers(lotNoReq).then((res) => {
      if (res.status) {
        setLotNumbers(res.data);
      } else {
        setLotNumbers([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setLotNumbers([]);
    });

  }
  // let workstation = 0;
  const getWorkStations = () => {
    const catReq = new WorkStationCategoryReq();
    catReq.workstationCategory = 3;
    catReq.unitId = Number(localStorage.getItem('unit_id'));
    workstationService.getWorkStationsForCategory(catReq).then((res) => {
      if (res.status) {
        console.log(res.data);
        setWorkStations(res.data);
        // workstation = (res.data[0].workstationId)
      } else {
        setWorkStations([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setWorkStations([]);
    });
  }

    
  const getLotNumberInfo = (lotNumber) => {
    const plant = Number(localStorage.getItem('unit_id'))
    const lotNoReq = new LotInformationRequest(lotNumber, plant, OperationTypeEnum.GRADING)
    service.getLotNumberInfo(lotNoReq).then((res) => {
      console.log(res.data);
      if (res.status) {
        setLotNoInfo(res.data)
        let boxWeight = (res.data.availableQuantity)/(res.data.boxes);
        setBoxWeight(boxWeight);
        assignGradingForm.setFieldsValue({
          productionInventoryId:res.data.productionInventoryId,
          saleOrderId:res.data.saleOrderId,
          saleOrderItemId:res.data.saleOrderItemId,
          saleOrder:res.data.saleOrderNo,
          count:res.data.count,
          boxes:res.data.outputBoxes,
          availableQuantity:res.data.availableQuantity,
          physicalQuantity:Math.round(res.data.availableQuantity),
        })
      } else {
        setLotNoInfo(undefined);
      }
    }).catch((err) => {
      setLotNoInfo(undefined);
      AlertMessages.getErrorMessage(err.message);
    });
  }
  const onFinish = () => {
    setDisable(true)
    const formInfo = assignGradingForm.getFieldsValue();
    formInfo.createdUser = localStorage.getItem('createdUser');
    formInfo.plantId = Number(localStorage.getItem('unit_id'))
    formInfo.workStationType = WorkStationTypeEnum.INTERNAL;
    console.log(workStations.filter(rec => rec.workstation === "Grading"));
    formInfo.workstation = 3
    console.log("my data is:",formInfo);
    assignGradingForm.validateFields().then(res => {
        gradingService.assignGradingOperation(formInfo).then((res) => {
          if (res.status) {
            AlertMessages.getSuccessMessage(res.internalMessage);
            onReset();
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }).catch((err) => {
          setDisable(false)
          AlertMessages.getErrorMessage(err.message);
        });
    });
  }
  const onReset=()=>{
    assignGradingForm.resetFields();
    
  }
  const calculateIssuingQty = () =>{
    const noOfBoxes = assignGradingForm.getFieldValue('boxes');
    const availableQuantity = assignGradingForm.getFieldValue('availableQuantity');
    // const boxWeight = availableQuantity/noOfBoxes;
    const physicalQuantity = (boxWeight*noOfBoxes).toFixed(2);
    if(Number(Number(physicalQuantity).toFixed(3)) <= Number(Number(availableQuantity).toFixed(3))){
      assignGradingForm.setFieldsValue({physicalQuantity:physicalQuantity});
    }else{
      assignGradingForm.setFieldsValue({physicalQuantity:0, boxes:0});
    }
    if(noOfBoxes===0){
      AlertMessages.getErrorMessage("Boxes cannot be 0. ");
    }
  }

  const handleQrScan = (lotcode) => {
    setShowQrScan(false)
    assignGradingForm.setFieldsValue({
      lotNumber:lotcode

    })
    
  }
  return (
    <>
    <Card title={<span style={{ color: 'white' }}>Grading Assignment</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={<Link to='/grade-inventory' ><Button className='panel_button' >View </Button></Link>}>
      <Form layout={'vertical'} form={assignGradingForm} name="control-hooks">

        <Row gutter={24}>
          <Form.Item name="productionInventoryId" >
            <Input hidden />
          </Form.Item>
          <Form.Item name="assignedTime" initialValue={moment().format('YYYY-MM-DD HH:mm:ss')}>
                  <Input hidden/>
              </Form.Item>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
          <label style={{textAlign:'start',marginRight:'45%'}}>Lot code <span style={{color: '#1890ff'}}> scan <QrcodeOutlined  onClick={(e) =>  setShowQrScan(true) } style={{ color: '#1890ff', fontSize: '20px' }} /></span> </label>
            <Form.Item name="lotNumber" label={false} rules={[{ required: true, message: 'Missing Lot No' }]}>
              <Select
                placeholder="Select Lot Code"
                allowClear
                onChange={getLotNumberInfo}
              >
                {lotNumbers.map(dropData => {
                  return <Option key={dropData.lotNumber} value={dropData.lotNumber}>{dropData.lotNumber}</Option>
                })}
              </Select>
            </Form.Item>
          </Col>
            <Form.Item name="saleOrderId">
              <Input hidden/>
            </Form.Item>
            <Form.Item name="saleOrderItemId">
              <Input hidden/>
            </Form.Item>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="saleOrder" label="SO Number" rules={[{ required: true, message: 'Missing Sale Order No' }]}>
              <Input disabled/>
            </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

            <Form.Item name="count" label="Count" rules={[{ required: true, message: 'Missing Count' }]}>
              <InputNumber style={{ width: '100%' }} min={0} disabled />
            </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>

            <Form.Item name="availableQuantity" label="Quantity Available" rules={[{ required: true, message: 'Missing Quantity Available' }]}>
              <InputNumber style={{ width: '100%' }} min={0} disabled />
            </Form.Item>

            </Col>

            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 4 }}>

            <Form.Item name="boxes" label="No. Of. Boxes" rules={[{ required: true, message: 'Missing No. Of. Boxes' }]}>
              <InputNumber style={{ width: '100%' }} min={0} onChange={calculateIssuingQty} />
            </Form.Item>

            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>

            <Form.Item name="physicalQuantity" label="Issuing Quantity" rules={[{ required: true, message: 'Missing Issuing Quantity' }]}>
              <InputNumber style={{ width: '100%' }} min={0} disabled />
            </Form.Item>

            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }} style={{display:'none'}}>
              <Form.Item name="workStationType" label="Workstation Type" rules={[{ required: true, message: 'Missing Workstation Type' }]} initialValue="INTERNAL">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
              <Form.Item name="workstation" label="Workstation" rules={[{ required: true, message: 'Missing Workstation' }]}>
              <Select
                placeholder="Select Workstation"
                allowClear
              >
                {workStations.map(dropData => {
                  return <Option key={dropData.workstationId} value={dropData.workstationId}>{dropData.workstation}</Option>
                })}
              </Select>
              </Form.Item>
            </Col>
         </Row>
         <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
          
            <Button type="primary"disabled={disable} onClick={onFinish} htmlType="submit" >
              Submit
            </Button>
            <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
                Reset
            </Button>
        </Col>

        </Row>
      </Form>
    </Card>

    <Modal
        className='qr-container'
        key={'modal' + Date.now()}
        width={'95%'}
        style={{ top: 30, alignContent: 'right' }}
        visible={showQrSacn}
        onCancel={() => { setShowQrScan(false) }}
        title={<React.Fragment>
        </React.Fragment>}
        footer={[

        ]}
      >
        

          <QrContainer handleScan={handleQrScan} />
          </Modal>
        
    </>
  );
}

export default AssignBeheadingToGrading;
